/**
 * Finds properties that are empty (i.e., "", null, or undefined) in all objects within the array.
 *
 * @param {Object[]} array - The array of objects to be checked.
 * @returns {string[]} An array of property names that are empty in all objects.
 */
export default function findEmptyProperties(array) {
  // count empty properties across all objects
  const propertyCounts = array.reduce((acc, item) => {
    Object.keys(item).forEach(key => {
      if (item[key] === '' || item[key] === null || item[key] === undefined) {
        acc[key] = (acc[key] || 0) + 1;
      }
    });
    return acc;
  }, {});

  // Filter properties that are empty in all objects
  const emptyKeys = Object.keys(propertyCounts).filter(
    key => propertyCounts[key] === array.length
  );

  return emptyKeys;
}
